import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center pt-16">
      <div className="text-center px-4">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-background-100 text-foreground-500">
          <i className="ri-emotion-sad-line text-4xl"></i>
        </div>
        <h1 className="text-4xl md:text-6xl font-bold text-foreground-50 font-heading mb-3">404</h1>
        <p className="text-base text-foreground-400 mb-6">抱歉，您访问的页面不存在</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-all duration-200 cursor-pointer"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
      </div>
    </main>
  );
}